/**
 * API client with Supabase authentication
 *
 * Attaches the Supabase access token to all requests to the backend API.
 */
import supabase from "./supabaseClient";
import { API_URL } from "./config";

// Export for convenience
export { API_URL };

/**
 * Make an authenticated fetch request to the backend API.
 * Automatically attaches the Supabase access token as a Bearer token.
 *
 * @param {string} endpoint - API endpoint (e.g., "/sessions")
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>}
 */
export async function apiFetch(endpoint, options = {}) {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = {
    ...options.headers,
  };

  if (session?.access_token) {
    headers["Authorization"] = `Bearer ${session.access_token}`;
  }

  // Only set Content-Type for non-FormData requests
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }

  return fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });
}
